import { useEffect } from 'react';
import { useColorContext } from '../contexts/ColorContext';
import { NearestColorSearchPanel } from '../components/NearestColorSearchPanel';
import { useToolInit } from '../hooks/useToolInit';

export function NearestTool() {
  const { displayResult, setInput, pantoneState, copiedField, copyToClipboard } = useColorContext();
  const { params } = useToolInit();

  // Deep-link: ?color= sets global active color
  useEffect(() => {
    if (params.color) setInput(params.color);
  }, [params.color, setInput]);

  if (!displayResult) {
    return <div style={{ padding: '48px 0', textAlign: 'center', color: 'var(--ink-3)', fontSize: 13 }}>Enter a valid color to see nearest matches.</div>;
  }

  return (
    <NearestColorSearchPanel
      baseHex={displayResult.hex}
      pantoneState={pantoneState}
      copiedField={copiedField}
      onCopy={copyToClipboard}
    />
  );
}
